import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=523c4cd0&scoped=true"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"
import style0 from "./IconLink.vue?vue&type=style&index=0&id=523c4cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c4cd0",
  null
  
)

export default component.exports